var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowOut = function SvgArrowOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.753 11.56-.007-6.995a.791.791 0 0 0-.223-.585c-.144-.153-.341-.23-.592-.23H6.936a.761.761 0 0 0-.572.23.747.747 0 0 0-.223.536c0 .205.077.381.23.53a.767.767 0 0 0 .544.216h2.48l2.996-.105-1.268 1.115-6.626 6.647c-.167.167-.25.35-.25.55a.72.72 0 0 0 .11.384c.075.12.17.216.286.286.121.074.251.111.39.111a.77.77 0 0 0 .55-.237l6.64-6.64 1.13-1.268-.112 2.87v2.607c0 .208.072.392.216.55.144.153.32.23.53.23a.735.735 0 0 0 .536-.23.776.776 0 0 0 .23-.571Z",
    fill: "currentColor"
  })));
};
export default SvgArrowOut;